import type { ThemeConfig } from 'antd';

/**
 * サイト全体のデザイントークン。
 * tailwind.config.js のカラーパレットと必ず対応させること。
 */
export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#0A2540',
    colorLink: '#1B4570',
    colorSuccess: '#0F9D58',
    colorError: '#D93025',
    colorInfo: '#1B4570',
    colorText: '#1A2733',
    colorTextSecondary: '#54677A',
    colorBorder: '#CBD6E2',
    colorBorderSecondary: '#E3E9F0',
    fontFamily: '"Noto Sans JP", "Hiragino Kaku Gothic ProN", Meiryo, sans-serif',
    fontSize: 16,
    borderRadius: 8,
    controlHeight: 44,
    lineHeight: 1.9,
  },
  components: {
    Button: {
      fontWeight: 700,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Card: {
      borderRadiusLG: 12,
      paddingLG: 32,
    },
    Input: {
      paddingBlock: 10,
      activeShadow: '0 0 0 3px rgba(242, 107, 33, 0.12)',
    },
    Select: {
      optionSelectedBg: '#FEF4EE',
    },
    Form: {
      labelColor: '#0A2540',
      verticalLabelPadding: '0 0 6px',
      itemMarginBottom: 20,
    },
    Collapse: {
      headerBg: 'transparent',
      contentBg: 'transparent',
      headerPadding: '20px 0',
      contentPadding: '0 0 20px',
    },
  },
};

export default theme;
